import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import WarningIconColored from '../../../icons/WarningIconColored'

function BlogPostHighlightedText({ warningText }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.iconWrapper}>
        <WarningIconColored/>
      </div>
      <div className={styles.textWrapper}>
        <SimpleBlockContent blocks={warningText}/>
      </div>
    </div>
  )
}

export default BlogPostHighlightedText
